import { ExternalIntegration } from 'api/clients/ExternalIntegrationsClient'
import { extractProfileInfo } from './utils'
import Styles from './ExternalIntegrationSelect.module.scss'
import { PlatformIcon } from 'screens/ScheduledPosts/PlatformIcon'
import Silhouette from 'components/Previews/InstagramPreview/silhouette.jpg'
import { useState } from 'react'
import cx from 'classnames'
import { ButtonSize } from 'blaze-ui/Button/Types'

export const ExternalIntegrationItem = ({
  externalIntegration,
  renderPlatformIcon = false,
  size = 'sm',
  showName = true,
  isSelected,
  nameClassName,
}: {
  externalIntegration: ExternalIntegration
  renderPlatformIcon?: boolean
  size?: ButtonSize
  showName?: boolean
  isSelected?: boolean
  nameClassName?: string
}) => {
  const [imageDidError, setImageDidError] = useState(false)
  const { avatar, name } = extractProfileInfo(externalIntegration)
  const src = imageDidError ? Silhouette : avatar || Silhouette

  let iconSize = 20
  if (size !== 'lg') iconSize = 16

  function renderIcon() {
    if (avatar) {
      return <img className={Styles.avatar} src={src} alt={name} onError={() => setImageDidError(true)} />
    }
    if (renderPlatformIcon) {
      return <PlatformIcon size={iconSize} platform={externalIntegration.provider} isSelected={isSelected} />
    }
    return <img className={Styles.avatar} src={src} alt={name} onError={() => setImageDidError(true)} />
  }

  return (
    <div className={cx(Styles.item, Styles[size])}>
      <div className={Styles.details}>
        {renderIcon()}
        {showName && <div className={cx(nameClassName, { [Styles.name]: size === 'sm' })}>{name}</div>}
      </div>
    </div>
  )
}
